import { Validator, ValidationResult, ValidatorOptions } from "./Index";
import i18n from '../helpers/i18n';

export function regex(pattern: RegExp, options: ValidatorOptions = new ValidatorOptions()): Validator {
    return {
        options: options,
        validate: (value: any) => {
            // eslint-disable-next-line
            const hasError = pattern.test(value) == false;
            const result = {
                hasError: hasError,
                errorMessage: options.errorMessage
                    ? options.errorMessage
                    : i18n.t('Value has incorrect format')
            } as ValidationResult;

            return result;
        }
    }
};
